import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 17"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  stroke: "currentColor",
  d: "M7.95 16.021h-.026a7 7 0 0 1-3.248-.667 6.4 6.4 0 0 1-2.459-2.04c-1.214-1.911-1.213-3.752-.807-5.258.41-1.524 1.236-2.7 1.647-3.218v-.001l.063-.078c.43-.423.735-.949.88-1.525a3.1 3.1 0 0 0-.077-1.768.3.3 0 0 1 .005-.193l-.469-.174.469.174a.36.36 0 0 1 .144-.174.46.46 0 0 1 .513.007c.123.086.28.179.44.273l.072.043.016.009.016.008a8.85 8.85 0 0 1 3.25 2.733 8 8 0 0 1 1.482 3.813l.184 1.671.759-1.5a7.3 7.3 0 0 0 .785-3.086.3.3 0 0 1 .059-.161.4.4 0 0 1 .164-.13.47.47 0 0 1 .45.038c.646.443 1.648 1.643 2.193 3.19.537 1.524.607 3.317-.481 5.008a6.8 6.8 0 0 1-2.578 2.23 7.4 7.4 0 0 1-3.446.776z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }